const capabilities = [
  {
    title: 'Modern Architecture',
    description: 'Clean, modular structures that scale with confidence.',
  },
  {
    title: 'Workflow Optimization',
    description: 'Streamlined processes for faster, safer delivery cycles.',
  },
  {
    title: 'Quality Assurance',
    description: 'Rigorous standards ensuring stability at every release.',
  },
  {
    title: 'Technical Evolution',
    description: 'Continuous adoption of emerging engineering practices.',
  },
];

export default function CapabilitySection() {
  return (
    <section
      className="w-full bg-foreground-950 py-28 px-6 md:px-10 lg:px-16"
      aria-label="Capabilities"
    >
      <div className="max-w-[1200px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-start gap-6 lg:gap-16 mb-24">
          <span className="font-label text-xs uppercase tracking-[0.15em] text-foreground-400 shrink-0 mt-1">
            Capabilities
          </span>
          <h2 className="font-heading text-[3.5rem] md:text-[4.5rem] lg:text-[5rem] font-bold text-background-50 leading-[0.95] tracking-tight">
            Future-ready<br />engineering
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {capabilities.map((cap) => (
            <div
              key={cap.title}
              className="bg-accent-100 rounded-2xl p-8 md:p-10"
            >
              <h3 className="font-body text-lg md:text-xl font-semibold text-foreground-900 mb-2">
                {cap.title}
              </h3>
              <p className="font-body text-sm text-foreground-600 leading-relaxed">
                {cap.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}